import React from "react";
import MetaTitle from "~/components/Shared/MetaTitle";
import { isMobile, isBrowser, isTablet } from 'react-device-detect';
import DesktopContent from "~/pages/Vid/DesktopContent/DesktopContent";
import MobileContent from "~/pages/Vid/MobileContent/MobileContent";

const Index = () => {

  return <React.Fragment>
    <MetaTitle>ID Validation</MetaTitle>
    {/* Tablet View */}
    {isTablet && <MobileContent />}
    {/* Browser and not Tablet View */}
    {isBrowser && !isTablet && <DesktopContent />}
    {/* Mobile and not Tablet View */}
    {isMobile && !isTablet && <MobileContent />}
  </React.Fragment>
}

export default Index;
